import { render, staticRenderFns } from "./TaskRecordGrid.vue?vue&type=template&id=5c41e9a5&scoped=true&"
import script from "./TaskRecordGrid.vue?vue&type=script&lang=js&"
export * from "./TaskRecordGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c41e9a5",
  null
  
)

export default component.exports